module.exports = __webpack_public_path__ + "img/坐标定位.966851bb.svg";